import {getMetaData, helpLearnMore, initialdata, logoutCall} from 'actions'
import {GET_META_DATA, INITIAL_DATA, LOGOUT} from 'actions/types'
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {VmoFullPageLoader} from 'vmo-library'
import {get} from 'utils/helper'
import {
  getAppToken,
  setAccountInfo,
  setMetadataInfo,
  setUserInfo,
  setRoleInfo,
  setAppToken,
  setLastActivity,
  setDomainInfo,
  setRememberMe as setRememberMeInfo,
  getLastActivity,
  getRememberMe,
  clearStorage,
  getProfilePicColor,
  setProfilePicColor,
  getUserInfo,
} from 'utils/local-storage'
import {Outlet, useNavigate} from 'react-router-dom'
import {currentSubscription} from 'actions/billing2'
import {getRole, getUserRolePermissions} from 'actions/roles'
import io from 'socket'
import LogoutModal from 'components/pages/LogoutModal'
import LearnMoreUrlProvider from './LearnMoreUrl'
import UserPermissionsProvider from './UserPermissions'
import UnsavedChangesProvider from './UnsavedChanges.context'

const token = getAppToken()

const AppProvider = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(Boolean(token))
  const {successLabels = []} = useSelector(state => state.apiReducer)
  const {initialData: userInitialData = {}} = useSelector(state => state.appReducer)
  const [tokenModal, setTokenModal] = useState(false)

  const {tokenExpired = false} = useSelector(state => state.appReducer)
  const {metadata} = useSelector(state => state.createUserAcct)

  const onLoad = () => {
    const date1 = getLastActivity()

    const date2 = Date.now()

    if (date1 !== undefined && date1 !== null) {
      const difference = date2 - date1
      const diff = (difference / 1000).toFixed(0)

      if (!getRememberMe()) {
        if (Number(diff) > 432000000) {
          dispatch(logoutCall())
        }
      }
    }
  }

  useEffect(() => {
    if (successLabels.includes(LOGOUT)) {
      clearStorage()
      navigate(`/`)
    }
    if (successLabels.includes(GET_META_DATA) && !getProfilePicColor()) {
      if (metadata) {
        setProfilePicColor(get(['profilePicColor'], metadata, '#9eb9d6'))
      }
    }
  }, [successLabels, navigate, metadata])

  useEffect(() => {
    if (getAppToken()) {
      dispatch(initialdata())
      dispatch(getMetaData())
      dispatch(helpLearnMore())
      dispatch(currentSubscription())
      dispatch(getUserRolePermissions())
      if (get(['roleId'], getUserInfo())) {
        dispatch(getRole(get(['roleId'], getUserInfo())))
      }
      io.emit('join_rooms', {
        token: getAppToken(),
      })
      io.connect()
      window.onload = () => {
        onLoad()
      }

      return () => {
        io.disconnect()
      }
    }
  }, [])

  useEffect(() => {
    if (tokenExpired) {
      setTokenModal(tokenExpired)
    }
  }, [tokenExpired])

  useEffect(() => {
    if (successLabels.includes(INITIAL_DATA)) {
      const date = Date.now()
      setLastActivity(date)
      setRememberMeInfo(false)
      setAppToken(get(['token'], userInitialData))
      setAccountInfo(get(['account'], userInitialData))
      setUserInfo(get(['user'], userInitialData))
      setMetadataInfo(get(['account', 'metadata'], userInitialData))
      setRoleInfo(get(['role'], userInitialData))
      setDomainInfo(get(['domainURL'], userInitialData).split('.')[0].replace('https://', ''))
      setIsLoading(false)
    }
  }, [successLabels, userInitialData])

  return isLoading ? (
    <VmoFullPageLoader />
  ) : (
    <>
      {tokenModal && <LogoutModal tokenModal={tokenModal} setTokenModal={setTokenModal} />}
      <UserPermissionsProvider>
        <LearnMoreUrlProvider>
          <UnsavedChangesProvider>
            <Outlet />
          </UnsavedChangesProvider>
        </LearnMoreUrlProvider>
      </UserPermissionsProvider>
    </>
  )
}

export default AppProvider
